// @flow
import * as React from 'react'
import { colors } from '@components/shared'

export type PropsType = {
  size?: number,
  color?: string
}

const BackIcon = (props: PropsType): React.Node => {
  return (
    <svg
      width={props.size || '100%'}
      height={props.size || '100%'}
      viewBox="0 0 16 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4616 29.9999C14.0619 29.9999 13.6622 29.8428 13.361 29.5293L0.437878 16.0918C-0.146122 15.4846 -0.146122 14.5153 0.437878 13.9081L13.361 0.47057C13.9548 -0.147243 14.9293 -0.157555 15.5366 0.444632C16.1443 1.04776 16.156 2.03713 15.5622 2.65432L3.68895 14.9999L15.5622 27.3456C16.156 27.9628 16.1443 28.9521 15.5366 29.5553C15.2373 29.8518 14.8493 29.9999 14.4616 29.9999Z"
        fill={props.color || colors.black}
      />
    </svg>
  )
}

export default BackIcon
